enum TipoMercado {
    Prospect = 1,
    internacional = 2,
    nacional = 3,
}

export default TipoMercado;
